/** Public marketing routes that may have prerendered HTML in index.html (SEO). */
export const MARKETING_PATHS = new Set([
  "/",
  "/about",
  "/about-us",
  "/how-it-works",
  "/pricing",
  "/coaching",
  "/free-trial",
  "/support",
  "/privacy-policy",
]);

export function isMarketingPath(pathname) {
  const path = (pathname || "/").replace(/\/$/, "") || "/";
  return MARKETING_PATHS.has(path);
}
